// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"40761b82","977":"7071b764"}[chunkId] + ".chunk.js";
};